"use strict";

exports.__esModule = true;
exports.Tablet = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactResponsive = require("react-responsive");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Tablet = function Tablet(_ref) {
  var children = _ref.children;
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    minWidth: 768,
    maxWidth: 991
  });
  return isTablet ? children : null;
};
exports.Tablet = Tablet;
Tablet.propTypes = {
  children: _propTypes.default.element.isRequired
};